<template>
  <ValidationProvider class="change-color"
                      :vid="vid"
                      :mode="mode"
                      :name="String(_uid)"
                      :rules="rules"
                      v-slot="{ errors, valid }">
    <v-textarea
      :class="customClass"
      v-model="innerValue"
      :error-messages="errors.length ? ['Je to povinné pole'] : []"
      :success="valid"
      v-bind="$attrs"
      v-on="$listeners"
      :rows="rows"
      :outlined="outlined" />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    // must be included in props
    value: {
      type: null,
      default: ''
    },
    rows: {
      type: String,
      default: '2'
    },
    outlined: {
      type: Boolean,
      deafult: false
    },
    customClass: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    vid: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
